import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import HowItWorks from './pages/HowItWorks';
import WhyItWorks from './pages/WhyItWorks';
import Pricing from './pages/Pricing';
import DemoRequest from './pages/DemoRequest';
import PortalDemo from './pages/PortalDemo';
import Contact from './pages/Contact';
import NotAboutTheFall from './pages/services/NotAboutTheFall';
import FitWorkshop from './pages/services/FitWorkshop';
import TrainTheTrainer from './pages/services/TrainTheTrainer';
import FitApp from './pages/services/FitApp';
import FYOUWorkshops from './pages/services/FYOUWorkshops';
import EssentialSkills from './pages/services/EssentialSkills';
import Security from './pages/Security';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/why-it-works" element={<WhyItWorks />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/demo" element={<DemoRequest />} />
          <Route path="/portal-demo" element={<PortalDemo />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/not-about-the-fall" element={<NotAboutTheFall />} />
          <Route path="/services/fit-workshop" element={<FitWorkshop />} />
          <Route path="/services/train-the-trainer" element={<TrainTheTrainer />} />
          <Route path="/services/fit-app" element={<FitApp />} />
          <Route path="/services/fyou-workshops" element={<FYOUWorkshops />} />
          <Route path="/services/essential-skills" element={<EssentialSkills />} />
          <Route path="/security" element={<Security />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
